import { configHelper as ch } from '@ilteducation/config';
import configHelper from './config-helper';

const countryCode = ch.getCountryCode();
const serviceName = configHelper.getServiceName();
const fullServiceName = configHelper.getFullServiceName();
const nodeEnv = process.env.NODE_ENV;
const toastClassName = configHelper.getToastClass(serviceName);
const basedLinks = configHelper.getBasedLinks();

export default class ConfigProvider {
  static get CONFIG() {
    return {
      nodeEnv,
      environment: 'VITE_ENVIRONMENT',
      context: 'manabua',
      serviceName,
      fullServiceName,
      countryCode,
      logoImageFile: `${serviceName}-logo.svg`,
      logoImageBWFile: `${serviceName}-logo-bw.svg`,
      toastClassName,
      authUrl: `VITE_AUTH_URL`,
      controlPanelUrl: 'VITE_CONTROL_PANEL_API_URL',
      apiLibraryUrl: `VITE_LIBRARY_API_URL`,
      authClientId: `VITE_MANABUA_AUTH_CLIENT_ID`,
      authRedirectUrl: `VITE_MANABUA_AUTH_REDIRECT_URI`,
      iltCloudUrl: 'http://ilt.cloud',
      audioCentralUrl: `VITE_AUDIO_CENTRAL_API_URL`,
      historyTrackerApiUrl: `VITE_HISTORY_TRACKER_URL`,
      contentRegistryUrl: `VITE_CONTENT_REGISTRY_API_URL`,
      curriculumUrl: `VITE_CURRICULUM_URL`,
      feedbackFormUrl: `VITE_MANABUA_FEEDBACK_URL`,
      teacherGuideUrl: `VITE_TEACHER_GUIDE_URL`,
      guidesLokaliseProject: 'VITE_GUIDES_LOKALISE_PROJECT',
      keywordsLokaliseProject: `VITE_KEYWORDS_LOKALISE_PROJECT`,
      babelfishUrl: `VITE_BABELFISH_URL`,
      iltConnectUrl: `VITE_ILT_CONENCT_URL`,
      cdnDomain: `VITE_CDN_DOMAIN`,
      showGuides: countryCode === 'se',
      showMaterials: countryCode === 'se',
      showGames: countryCode === 'se',
      showTeacherGuide: countryCode === 'se',
      showNativeLanguageTeacher: countryCode === 'se',
      showCurriculum: true,
      // links
      supportUrl: `VITE_SUPPORT_PAGE_URL`,
      settingsUrl: basedLinks.settings,
      profileUrl: basedLinks.profile,
      homeUrl: basedLinks.home,
      latestNewsUrl: basedLinks.latestNews,
      basePath: import.meta.env.BASE_URL || '/',
      nativeLanguageTeacherUrl: `VITE_NATIVE_LANGUAGE_TEACHER_URL`,
    };
  }

  static value(name) {
    const value = name.split('.').reduce((obj, key) => {
      if (!(key in obj)) {
        console.error(`Configuration: There is no key named "${name}"`);
        return {};
      }
      return obj[key];
    }, this.CONFIG);

    if (!value) {
      console.debug(`Configuration: Value for "${name}" is not defined `);
      return undefined;
    }

    if (typeof value === 'string' && value.startsWith('VITE_')) {
      const envName = process.env[value] ? value : `${value}_${countryCode.toUpperCase()}`;
      const envValue = process.env[envName];

      if (envValue) {
        return envValue;
      }

      console.debug(`Configuration: Environment variable "${envName}" is not defined`);
    }

    return value;
  }
}
